import React from 'react';
import PropTypes from 'prop-types';

const Check = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.128"
    height="13.389"
    viewBox="0 0 14.128 13.389"
    className={className}
  >
    <path
      d="M-1.469,1.472A1.617,1.617,0,0,0-.026.754L6.735-9.375a1.79,1.79,0,0,0,.33-1,1.532,1.532,0,0,0-1.589-1.538,1.467,1.467,0,0,0-1.377.806L-1.49-2.366-4.274-5.632A1.49,1.49,0,0,0-5.49-6.189,1.517,1.517,0,0,0-7.064-4.644,1.567,1.567,0,0,0-6.61-3.523L-2.845.85A1.7,1.7,0,0,0-1.469,1.472Z"
      transform="translate(7.064 11.917)"
      fill={fill}
    />
  </svg>
);

Check.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Check;
